<template>
	<div class="special-box-goods-search--modal">
		<ManagingSection>
			<ManagingBox title="제품명">
				<input v-model="productTitle" type="text" />
			</ManagingBox>
			<ManagingBox title="브랜드">
				<search-brand @change="setBrand" />
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button @click="getSearch(0)" class="btn-main blue" type="button">
				검색
			</button>
		</div>
		<ManagingSection :isTable="true" :tableMaxHeight="300">
			<template slot="infoSection">
				<span class="section__info__left"
					>검색결과 : {{ contentTotal | currency }} 개</span
				>
				<div class="section__info__right">
					<select
						class="select section__info__items"
						aria-label="페이지 당 출력 갯수"
						v-model="limit"
						@change="onLimitChange"
					>
						<option :value="10">10개씩 보기</option>
						<option :value="20">20개씩 보기</option>
						<option :value="30">30개씩 보기</option>
						<option :value="50">50개씩 보기</option>
						<option :value="100">100개씩 보기</option>
					</select>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>
							<input
								type="checkbox"
								ref="toggleAll"
								@change="toggleAll($event.target.checked)"
							/>
						</th>
						<th>제품번호</th>
						<th>브랜드명</th>
						<th>제품명</th>
						<th>평점</th>
						<th>리뷰 수</th>
						<th>노출상태</th>
						<th>단종여부</th>
					</tr>
				</thead>
				<tbody v-if="searchResult.length === 0">
					<tr>
						<td colspan="8">검색결과가 없습니다.</td>
					</tr>
				</tbody>
				<tbody v-if="searchResult.length > 0">
					<tr :key="item.idProduct" v-for="item in searchResult">
						<td>
							<input
								type="checkbox"
								ref="itemAddToggle"
								@change="itemAddToggle($event, item)"
							/>
						</td>
						<td>{{ item.idProduct }}</td>
						<td>{{ item.brandTitle }}</td>
						<td>
							<table-item-product-box
								@click.native="linkToProduct(item.idProduct)"
								:src="item.filePath"
								:name="item.productTitle"
							/>
						</td>
						<td>{{ item.ratingAvg }}</td>
						<td>{{ item.reviewCount }}</td>
						<td>{{ item.isDisplay ? '노출' : '비노출' }}</td>
						<td>{{ item.isDiscontinue ? '단종' : '미단종' }}</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<pagination-box
			class="pagination-box"
			:totalItem="getTotal"
			:offset="getCursor"
			:limit="limit"
			:pageLengPerOne="pageGroupLimit"
			@to="paging"
		/>
		<div class="btn-wrap-main">
			<button @click="adding" class="btn-main blue" type="button">
				추가하기
			</button>
			<button @click="close" class="btn-main blue bordered" type="button">
				닫기
			</button>
		</div>
	</div>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import TableItemProductBox from '@/components/TableItemProductBox.vue';
	import PaginationBox from '@/components/PaginationBox';
	import SpecialBoxMixin from '@/components/modals/modules/_SpecialBoxMixin';

	export default {
		name: 'SpecialBoxGoodsSearch',
		mixins: [SpecialBoxMixin],
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrand,
			TableItemProductBox,
			PaginationBox,
		},
		mounted() {
			this.getSearch();
		},
		methods: {
			linkToProduct(id) {
				window.open(
					`${this.$store.state.env.adminDomain}/product/update_product?id=${id}`
				);
			},
			getSearch(offset) {
				this.initCheckedItem();

				if (typeof offset === 'number') {
					this.offset = offset;
				}

				const params = {
					productTitle: this.valueOrNull(this.productTitle),
					idBrand: this.idBrand,
					limit: this.limit,
					offset: this.offset,
				};

				this.$axiosAdmin2
					.post('/api/display/home/brand/products/search', params)
					.then(({ data }) => {
						this.searchResult = data.data;
						this.contentTotal = data.contentTotal;
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			adding() {
				this.$store.commit('SPBoxGoods/add', this.itemChecked);

				if (this.$store.state.SPBoxGoods.isSuccess) {
					this.$store.commit('modal/toggleModal', false);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.pagination-box {
		padding-top: 1em;
	}
</style>
